import Lottie from "lottie-react";
import styles from "./index.module.less";
import jiantou from "@/assets/lottie/jiantou.json";
import jiantouOrange from "@/assets/lottie/jiantou_orange.json";
import { Typography } from "antd";
import classNames from "classnames";
import useHoverLottie from "@/hooks/useHoverLottie";
import TextBg from "../../imgs/text_bg.svg?react";

export interface ChannelCardProps {
  img?: string;
  desc?: string;
  date?: string;
  vertical?: boolean;
  position?: "top" | "bottom";
  type?: "default" | "more";
  link?: string;
}
const { Paragraph } = Typography;
const ChannelCard = ({
  img,
  desc,
  date,
  vertical = false,
  position = "top",
  type = "default",
  onClick,
  link,
}: ChannelCardProps & {
  onClick?: () => void;
}) => {
  const { playLottieOnce, stopLottie, lottieOptions } = useHoverLottie({
    animationData: jiantou,
  });
  const {
    playLottieOnce: playLottieOnce2,
    stopLottie: stopLottie2,
    lottieOptions: lottieOptions2,
  } = useHoverLottie({
    animationData: jiantouOrange,
  });
  const renderVerticalCard = () => {
    return (
      <div
        className={styles.verticalCard}
        onMouseEnter={playLottieOnce}
        onMouseLeave={stopLottie}
        onClick={() => {
          window.open(link, "_blank");
        }}
      >
        {/* <div className={styles.contentBg}></div>
          <WhiteBg /> */}
        <div className={styles.img}>
          <img src={img} alt="" />
        </div>
        <div
          className={classNames(styles.content, {
            [styles[position]]: position,
          })}
        >
          <TextBg className={styles.contentBg} />
          <div className={styles.contentInner}>
            <div className={styles.desc}>
              <Paragraph
                ellipsis={{
                  rows: 3,
                  expandable: false,
                }}
              >
                {desc}
              </Paragraph>
            </div>
            <div className={styles.date}>
              {date}
              <Lottie
                {...lottieOptions}
                className={styles.moreIcon}
                style={{ marginLeft: ".2rem" }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderHorizontalCard = () => {
    return (
      <div
        className={styles.horizontalCard}
        onMouseEnter={playLottieOnce2}
        onMouseLeave={stopLottie2}
        onClick={() => {
          window.open(link, "_blank");
        }}
      >
        <div className={styles.content}>
          <div className={styles.date}>
            {date}
            <Lottie {...lottieOptions2} className={styles.moreIcon} />
          </div>
          <div className={styles.desc}>
            <Paragraph
              ellipsis={{
                rows: 3,
                expandable: false,
              }}
            >
              {desc}
            </Paragraph>
          </div>
        </div>
      </div>
    );
  };
  const renderMoreCard = () => {
    return (
      <div
        className={styles.moreCard}
        onMouseEnter={playLottieOnce}
        onMouseLeave={stopLottie}
        onClick={onClick}
      >
        MORE
        <Lottie {...lottieOptions} />
      </div>
    );
  };
  if (type === "more") {
    return renderMoreCard();
  }
  return <>{vertical ? renderVerticalCard() : renderHorizontalCard()}</>;
};
export default ChannelCard;
